<template>
  <div class="page-container">
    <h1 class="user-center-h1">{{i18n.t('upgrade_page_views_user_info_index_719')}}</h1>
    <div v-loading="!inited" class="user-info-card">
      <div class="photo-list">
        <div class="info-title">
          <span>{{i18n.t('upgrade_page_views_user_info_index_720')}}</span>
        </div>
        <div class="list-wrap">
          <div v-for="i in 9" :key="`photo-${i}`" class="photo-wrap">
            <el-upload
              class="photo-uploader"
              action="*"
              accept="image/png,image/jpg,image/gif,image/jpeg,image/webp"
              :show-file-list="false"
              :http-request="handleImgCut(i - 1)"
              :beforeAvatarUpload="beforeAvatarUpload"
            >
              <div
                v-if="photoAlbumVoList[i - 1]"
                class="photo-detail"
                :class="i === 1 && 'pointer'"
                :style="{
                  backgroundImage: `url(${
                    photoAlbumVoList[i - 1].imageUrl
                  }?d=700x800)`
                }"
              >
                <div
                  v-if="i !== 1"
                  class="delete-photo pointer"
                  @click.stop="deletePhoto(photoAlbumVoList[i - 1].id, i)"
                >
                  <fps-icon type="close" size="12" color="#fff" />
                </div>
                <div v-else class="avatar-tip">{{i18n.t('upgrade_page_views_user_info_index_721')}}</div>
              </div>
              <div v-else class="add-photo">
                <i
                  v-if="uploading"
                  class="el-icon-loading"
                  style="font-size: 28px; color: #E8EAEE;"
                ></i>
                <fps-icon v-else type="add-small" size="28" color="#D8D8D8" />
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="info-detail">
        <!-- 暱稱 -->
        <div class="info-title">
          <span>{{i18n.t('upgrade_page_views_user_info_index_722')}}</span>
          <div v-if="handleInputVisible.nickname" class="editing-btn" />
          <div v-else class="edit-btn pointer" @click="handleInput('nickname')">
            <fps-icon type="edit" size="18" />
          </div>
        </div>
        <div class="info-content">
          <template v-if="handleInputVisible.nickname">
            <input
              v-model="editUserInfo.nickname"
              class="edit-input"
              maxlength="10"
            />
            <div class="tool-btns">
              <button class="cancel-btn" @click="cancelEdit('nickname')">{{i18n.t('upgrade_page_layout_header_42')}}</button>
              <button class="confirm-btn" @click="submitUserInfo('nickname')">
                <i v-if="editingObj.nickname" class="el-icon-loading" />
                <span v-else>{{i18n.t('upgrade_page_views_order_components_price_unit_305')}}</span>
              </button>
            </div>
          </template>
          <span v-else>{{ editUserInfo.nickname }}</span>
        </div>
        <!-- 語音 -->
        <div class="info-title">
          <span>{{i18n.t('upgrade_page_views_user_info_index_723')}}</span>
          <div class="editing-btn" />
        </div>
        <div class="info-content">
          <div v-if="editUserInfo.voiceUrl" class="voice-info">
            <fps-voice class="skill-voice" :src="editUserInfo.voiceUrl" />
            <div class="delete-voice pointer" @click="deleteVoice">
              <fps-icon type="close" size="12" color="#fff" />
            </div>
          </div>
          <div v-else class="upload-voice-wrap">
            <div
              v-show="audioStatus !== 0"
              class="recording-voice"
              @click="audioStop"
            >
              <div class="stop-icon">
                <fps-icon
                  v-show="[1, 3].includes(audioStatus)"
                  type="time-out"
                  color="#fff"
                  size="8"
                />
                <fps-icon
                  v-show="[2, 4].includes(audioStatus)"
                  type="play"
                  color="#fff"
                  size="8"
                />
              </div>
              <div
                class="record-line"
                :class="
                  [1, 3].includes(audioStatus) ? 'play-state' : 'stop-state'
                "
              >
                <span v-for="i in 54" :key="i" />
              </div>
              <span class="voice-second"
                >{{
                  [1, 2].includes(audioStatus) ? audioSeconds : audioPlayed
                }}"</span
              >
            </div>
            <div
              v-show="audioStatus !== 0 && audioStatus !== 1"
              class="tool-btns"
            >
              <button
                class="cancel-btn"
                @click="
                  audioStatus = 0;
                  cancelEdit('voiceUrl');
                "
              >{{i18n.t('upgrade_page_layout_header_42')}}</button>
              <button class="confirm-btn" @click="updateRecord">
                <i v-if="editingObj.voiceUrl" class="el-icon-loading" />
                <span v-else>{{i18n.t('upgrade_page_views_order_components_price_unit_305')}}</span>
              </button>
            </div>
            <div v-show="audioStatus === 0" class="uploader">
              <button class="record-voice" @click="recordStart">
                <fps-icon class="record-icon" type="mic" size="20" />
                <span>{{i18n.t('upgrade_page_views_user_info_index_724')}}</span>
              </button>
              <span class="select-text">{{i18n.t('upgrade_page_views_user_info_index_725')}}</span>
              <el-upload
                class="voice-uploader"
                action="*"
                accept=".mp3,.wma,.m4a,.wav,.ape,.flac,.aac"
                :show-file-list="false"
                :http-request="handleVoiceSuccess"
                :beforeAvatarUpload="validateVoiceInfo"
              >
                <div class="add-voice">
                  <i
                    v-if="this.editingObj.voiceUrl"
                    class="el-icon-loading"
                  ></i>
                  <button v-else class="upload-voice">
                    <fps-icon
                      class="record-icon"
                      type="file-upload"
                      size="18"
                    />
                    <span>{{i18n.t('upgrade_page_views_user_info_index_726')}}</span>
                  </button>
                </div>
              </el-upload>
            </div>
            <div v-show="audioStatus === 0" class="tip-text">{{i18n.t('upgrade_page_views_user_info_index_727')}}</div>
          </div>
        </div>
        <!-- 文字介紹 -->
        <div class="info-title">
          <span>{{i18n.t('upgrade_page_views_user_info_index_728')}}</span>
          <div v-if="handleInputVisible.description" class="editing-btn" />
          <div
            v-else-if="editUserInfo.description"
            class="edit-btn pointer"
            @click="handleInput('description')"
          >
            <fps-icon type="edit" size="18" />
          </div>
          <div v-else class="editing-btn" />
        </div>
        <div class="info-content">
          <template v-if="handleInputVisible.description">
            <div class="textarea-wrap" :class="descriptionFocus && 'focus'">
              <textarea
                v-model="editUserInfo.description"
                class="edit-textarea"
                rows="4"
                :placeholder="i18n.t('upgrade_page_views_user_info_index_729')"
                maxlength="500"
                @focus="descriptionFocus = true"
                @blur="descriptionFocus = false"
              />
              <div class="description-count">
                {{ editUserInfo.description.length }}/500
              </div>
            </div>
            <div class="tool-btns">
              <button class="cancel-btn" @click="cancelEdit('description')">{{i18n.t('upgrade_page_layout_header_42')}}</button>
              <button
                class="confirm-btn"
                @click="submitUserInfo('description')"
              >
                <i v-if="editingObj.description" class="el-icon-loading" />
                <span v-else>{{i18n.t('upgrade_page_views_order_components_price_unit_305')}}</span>
              </button>
            </div>
          </template>
          <div
            v-else-if="editUserInfo.description"
            v-html="descriptionText"
            class="text-content"
          />
          <button v-else class="add-info" @click="handleInput('description')">
            <fps-icon class="add-icon" type="add" size="20" />
            <span>{{i18n.t('upgrade_page_views_user_info_index_730')}}</span>
          </button>
        </div>
        <!-- 性別 -->
        <div class="info-title">
          <span>{{i18n.t('upgrade_page_views_player_list_index_175')}}</span>
          <div v-if="handleInputVisible.sex" class="editing-btn" />
          <div
            v-else-if="editUserInfo.sex"
            class="edit-btn pointer"
            @click="handleInput('sex')"
          >
            <fps-icon type="edit" size="18" />
          </div>
          <div v-else class="editing-btn" />
        </div>
        <div class="info-content">
          <template v-if="handleInputVisible.sex">
            <el-select
              class="select-sex"
              v-model="editUserInfo.sex"
              :placeholder="i18n.t('upgrade_page_views_user_info_index_731')"
            >
              <el-option
                v-for="item in sexOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div class="tool-btns">
              <button class="cancel-btn" @click="cancelEdit('sex')">{{i18n.t('upgrade_page_layout_header_42')}}</button>
              <button class="confirm-btn" @click="submitUserInfo('sex')">
                <i v-if="editingObj.sex" class="el-icon-loading" />
                <span v-else>{{i18n.t('upgrade_page_views_order_components_price_unit_305')}}</span>
              </button>
            </div>
          </template>
          <span v-else-if="editUserInfo.sex">{{
            parseSex(editUserInfo.sex)
          }}</span>
          <button v-else class="add-info" @click="handleInput('sex')">
            <fps-icon class="add-icon" type="add" size="20" />
            <span>{{i18n.t('upgrade_page_views_user_info_index_732')}}</span>
          </button>
        </div>
        <!-- 出生日期 -->
        <div class="info-title">
          <span>{{i18n.t('upgrade_page_views_user_info_index_733')}}</span>
          <div v-if="handleInputVisible.birthday" class="editing-btn" />
          <div
            v-else-if="editUserInfo.birthday"
            class="edit-btn pointer"
            @click="handleInput('birthday')"
          >
            <fps-icon type="edit" size="18" />
          </div>
          <div v-else class="editing-btn" />
        </div>
        <div class="info-content">
          <template v-if="handleInputVisible.birthday">
            <DateInput v-model="editUserInfo.birthday" startTime="1921/1/1" />
            <div class="tip-text">{{i18n.t('upgrade_page_views_user_info_index_734')}}</div>
            <div class="tool-btns">
              <button class="cancel-btn" @click="cancelEdit('birthday')">{{i18n.t('upgrade_page_layout_header_42')}}</button>
              <button class="confirm-btn" @click="submitUserInfo('birthday')">
                <i v-if="editingObj.birthday" class="el-icon-loading" />
                <span v-else>{{i18n.t('upgrade_page_views_order_components_price_unit_305')}}</span>
              </button>
            </div>
          </template>
          <span v-else-if="editUserInfo.birthday">{{
            parseBirthday(editUserInfo.birthday)
          }}</span>
          <button v-else class="add-info" @click="handleInput('birthday')">
            <fps-icon class="add-icon" type="add" size="20" />
            <span>{{i18n.t('upgrade_page_views_user_info_index_735')}}</span>
          </button>
        </div>
        <div class="info-title">
          <span>{{i18n.t('upgrade_page_views_user_info_index_736')}}</span>
          <div v-if="handleInputVisible.fbUrl" class="editing-btn" />
          <div
            v-else-if="editUserInfo.fbUrl"
            class="edit-btn pointer"
            @click="handleInput('fbUrl')"
          >
            <fps-icon type="edit" size="18" />
          </div>
          <div v-else class="editing-btn" />
        </div>
        <div class="info-content">
          <template v-if="handleInputVisible.fbUrl">
            <div class="textarea-wrap" :class="fbUrlFocus && 'focus'">
              <textarea
                v-model="editUserInfo.fbUrl"
                class="edit-textarea"
                rows="4"
                :placeholder="i18n.t('upgrade_page_views_user_info_index_737')"
                maxlength="500"
                @focus="fbUrlFocus = true"
                @blur="fbUrlFocus = false"
              />
              <div class="description-count">
                {{ editUserInfo.fbUrl.length }}/500
              </div>
            </div>
            <div class="tool-btns">
              <button class="cancel-btn" @click="cancelEdit('fbUrl')">{{i18n.t('upgrade_page_layout_header_42')}}</button>
              <button class="confirm-btn" @click="submitUserInfo('fbUrl')">
                <i v-if="editingObj.fbUrl" class="el-icon-loading" />
                <span v-else>{{i18n.t('upgrade_page_views_order_components_price_unit_305')}}</span>
              </button>
            </div>
          </template>
          <div v-else-if="editUserInfo.fbUrl" class="text-content">
            {{ editUserInfo.fbUrl }}
          </div>
          <button v-else class="add-info" @click="handleInput('fbUrl')">
            <fps-icon class="add-icon" type="add" size="20" />
            <span>{{i18n.t('upgrade_page_views_user_info_index_736')}}</span>
          </button>
        </div>
        <div class="info-title">
          <span>{{i18n.t('upgrade_page_views_user_info_index_738')}}</span>
          <div v-if="handleInputVisible.igUrl" class="editing-btn" />
          <div
            v-else-if="editUserInfo.igUrl"
            class="edit-btn pointer"
            @click="handleInput('igUrl')"
          >
            <fps-icon type="edit" size="18" />
          </div>
          <div v-else class="editing-btn" />
        </div>
        <div class="info-content">
          <template v-if="handleInputVisible.igUrl">
            <div class="textarea-wrap" :class="instagramFocus && 'focus'">
              <textarea
                v-model="editUserInfo.igUrl"
                class="edit-textarea"
                rows="4"
                :placeholder="i18n.t('upgrade_page_views_user_info_index_739')"
                maxlength="500"
                @focus="fbUrlFocus = true"
                @blur="fbUrlFocus = false"
              />
              <div class="description-count">
                {{ editUserInfo.igUrl.length }}/500
              </div>
            </div>
            <div class="tool-btns">
              <button class="cancel-btn" @click="cancelEdit('igUrl')">{{i18n.t('upgrade_page_layout_header_42')}}</button>
              <button class="confirm-btn" @click="submitUserInfo('igUrl')">
                <i v-if="editingObj.igUrl" class="el-icon-loading" />
                <span v-else>{{i18n.t('upgrade_page_views_order_components_price_unit_305')}}</span>
              </button>
            </div>
          </template>
          <div v-else-if="editUserInfo.igUrl" class="text-content">
            {{ editUserInfo.igUrl }}
          </div>
          <button v-else class="add-info" @click="handleInput('igUrl')">
            <fps-icon class="add-icon" type="add" size="20" />
            <span>{{i18n.t('upgrade_page_views_user_info_index_738')}}</span>
          </button>
        </div>
      </div>
      <Cropper
        v-if="cutDialogVisiable"
        :cutDialogVisiable="cutDialogVisiable"
        :originData="originData"
        @closeCut="closeCut"
        @handleAvatarSuccessP="handleAvatarSuccess"
      />
      <audio muted="muted" id="audio"></audio>
    </div>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { uploadImageToS3, saveUserInfo, uploadFileToS3 } from '@/api';
import Cropper from '@/components/ImgCropper/photoAlbum';
import Recorder from 'js-audio-recorder';
import DateInput from './date-input';

export default {
  name: 'SetUserInfo',
  components: {
    Cropper,
    DateInput
  },
  data() {
    return {
      uploading: false,
      editUserInfo: {},
      handleInputVisible: {},
      editingObj: {},
      cutDialogVisiable: false,
      descriptionFocus: false,
      fbUrlFocus: false,
      instagramFocus: false,
      titTokFocus: false,
      sexOptions: [
        {
          value: 'Male',
          label: i18n.t('filters_index_79')
        },
        {
          value: 'Female',
          label: i18n.t('filters_index_80')
        }
      ],
      audioStatus: 0, // 0: 待录制； 1: 录制中； 2: 录制结束（待播放）； 3: 播放中； 4: 暫停中
      audioSeconds: 0, // 錄音時長
      audioFile: null, // 錄音後的文件數據
      audioPlayed: 0, // 播放時長
      userInfo: {},
      inited: false,
      i18n: i18n
    };
  },
  computed: {
    descriptionText() {
      return this.editUserInfo.description.replace(/\n/g, '<br>');
    },
    photoAlbumVoList() {
      return (this.userInfo && this.userInfo.photoAlbumVoList) || [];
    }
  },
  created() {
    this.editAttrList = [
      'nickname',
      'voiceUrl',
      'description',
      'sex',
      'birthday',
      'fbUrl',
      'igUrl',
      'tkUrl'
    ];
    this.getDefaultInfo();
  },
  mounted() {
    this.photoUploader = document.querySelector('#photo-uploader');
  },
  methods: {
    parseBirthday(time) {
      if (!time) return '';
      const d = new Date(time);
      return i18n.t('upgrade_page_views_user_info_index_740', [d.getFullYear(),d.getMonth() + 1,d.getDate()]);
    },
    async recordStart() {
      if (this.recording && this.editingObj.voiceUrl) return;
      this.recording = true;
      if (!this.recorder) {
        try {
          await Recorder.getPermission();
          this.recorder = new Recorder();
        } catch (e) {
          this.recording = false;
          this.$message.error({
            message: i18n.t('upgrade_page_views_user_info_index_741')
          });
          return;
        }
      }
      this.recorder.start().then(() => {
        this.audioStatus = 1;
        this.audioSeconds = 0;
        this.interval = setInterval(() => {
          this.audioSeconds++;
          if (this.audioSeconds === 60) {
            this.audioStop();
          }
        }, 1000);
        this.recorder.onplay = () => {
          // 播放
          this.audioPlayed = 0;
          this.audioStatus = 3;
          this.interval = setInterval(() => {
            this.audioPlayed++;
          }, 1000);
        };
        this.recorder.onresumeplay = () => {
          // 恢復播放
          this.audioStatus = 3;
          this.interval = setInterval(() => {
            this.audioPlayed++;
          }, 1000);
        };
        this.recorder.onpauseplay = () => {
          // 暫停播放
          this.audioStatus = 4;
          clearInterval(this.interval);
        };
        this.recorder.onplayend = () => {
          // 播放結束
          this.audioStatus = 2;
          clearInterval(this.interval);
          this.interval = null;
          this.audioPlayed = this.audioSeconds;
        };
      });
    },

    audioStop() {
      switch (this.audioStatus) {
        case 1: {
          if (!this.recorder) return;
          // this.recorder.stop()
          this.recording = false;
          this.audioFile = this.recorder.getWAVBlob();
          this.audioSeconds = Math.floor(this.recorder.duration);
          clearInterval(this.interval);
          this.interval = null;
          if (this.audioSeconds < 3) {
            this.audioStatus = 0;
            this.audioSeconds = 0;
            this.$message(i18n.t('upgrade_page_views_user_info_index_742'));
          } else {
            this.audioStatus = 2;
          }
          break;
        }
        case 2: {
          // 開始播放录音
          this.recorder.play();
          break;
        }
        case 3: {
          // 暂停
          this.recorder.pausePlay();
          break;
        }
        case 4: {
          // 继续播放
          this.recorder.resumePlay();
          break;
        }
      }
    },
    parseSex(sex) {
      if (sex === 'Male') {
        return i18n.t('filters_index_79');
      } else if (sex === 'Female') {
        return i18n.t('filters_index_80');
      }
      return '';
    },
    cancelEdit(attr) {
      this.$set(this.handleInputVisible, attr, false);
      let data = this.userInfo[attr];
      if (attr === 'sex' && data === 'NobodyKnow') data = '';
      this.$set(this.editUserInfo, attr, data);
    },
    async getDefaultInfo() {
      const { data: userInfo } = await this.$http.get('/user/info');
      this.userInfo = userInfo;
      if (userInfo && !this.notFirst) {
        this.notFirst = true;
        const editUserInfo = {};
        const handleInputVisible = {};
        const editingObj = {};
        this.editAttrList.forEach(item => {
          editUserInfo[item] = userInfo[item];
          handleInputVisible[item] = false;
          editingObj[item] = false;
        });
        editUserInfo.sex === 'NobodyKnow' && (editUserInfo.sex = '');
        editUserInfo.description = editUserInfo.description || '';
        editUserInfo.fbUrl = editUserInfo.fbUrl || '';
        editUserInfo.igUrl = editUserInfo.igUrl || '';
        editUserInfo.tkUrl = editUserInfo.tkUrl || '';
        this.editUserInfo = editUserInfo;
        this.editingObj = editingObj;
        this.handleInputVisible = handleInputVisible;
      } else if (userInfo) {
        const editUserInfo = {};
        this.editAttrList.forEach(item => {
          editUserInfo[item] = userInfo[item];
        });
        editUserInfo.description = editUserInfo.description || '';
        editUserInfo.fbUrl = editUserInfo.fbUrl || '';
        editUserInfo.igUrl = editUserInfo.igUrl || '';
        editUserInfo.tkUrl = editUserInfo.tkUrl || '';
        this.editUserInfo = editUserInfo;
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    closeCut() {
      this.cutDialogVisiable = false;
      this.uploading = false;
    },
    handleInput(attr) {
      this.$set(this.handleInputVisible, attr, true);
    },
    deletePhoto(id, i) {
      this.$http
        .post('/user/photo/delete', { id })
        .then(() => {
          this.$message.warning(i18n.t('upgrade_page_views_user_info_index_743'));
          const photoAlbumVoList = this.userInfo.photoAlbumVoList || [];
          photoAlbumVoList.splice(i - 1, 1);
          this.$set(this.userInfo, 'photoAlbumVoList', photoAlbumVoList);
        })
        .catch(() => {
          this.$message.error(i18n.t('upgrade_page_views_user_info_index_744'));
        });
    },
    /**
     * @description 音頻校驗
     */
    validateVoiceInfo(file) {
      if (this.editingObj.voiceUrl) return Promise.reject();
      this.$set(this.editingObj, 'voiceUrl', true);
      return new Promise((resolve, reject) => {
        if (file) {
          if (file.size > 1024 * 1024 * 3) return reject(i18n.t('upgrade_page_views_user_info_index_745'));
          const url = window.URL.createObjectURL(file);
          const audio = document.querySelector('#audio');
          audio.onloadedmetadata = () => {
            const duration = audio.duration;
            window.URL.revokeObjectURL(url);

            if (duration > 60 || duration < 3) {
              return reject(i18n.t('upgrade_page_views_user_info_index_746'));
            } else {
              resolve(Math.ceil(duration));
            }
          };
          audio.onerror = () => {
            reject(i18n.t('upgrade_page_views_user_info_index_747'));
          };
          audio.src = url;
        } else {
          reject(i18n.t('upgrade_page_views_user_info_index_748'));
        }
      });
    },
    //圖片上傳以前的鉤子函數
    beforeAvatarUpload(file) {
      const { type, size } = file;
      const fileTypeList = [
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/webp'
      ];
      if (this.uploading) {
        this.$message(i18n.t('upgrade_page_views_user_info_index_749'));
        return Promise.reject();
      }
      if (!fileTypeList.includes(type.toLowerCase())) {
        this.$message.error(i18n.t('upgrade_page_views_user_info_index_750'));
        return Promise.reject();
      }
      if (size > 1024 * 1024 * 3) {
        this.$message.error(i18n.t('upgrade_page_views_user_info_index_751'));
        return Promise.reject();
      }
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          const img = new Image();
          img.onload = () => {
            console.log(img.width, img.height);
            if (img.width < 800 || img.height < 800) {
              return this.$confirm({
                content:
                  i18n.t('upgrade_page_views_user_info_index_752'),
                confirmButtonText: i18n.t('upgrade_page_views_user_info_index_753'),
                cancelButtonText: i18n.t('upgrade_page_views_user_info_index_754'),
                closeOnPressEscape: false
              })
                .then(reject)
                .catch(resolve);
            }
            return resolve();
          };
          img.src = fileReader.result;
        };
      });
    },
    updateRecord() {
      if (this.editingObj.voiceUrl) return;
      this.$set(this.editingObj, 'voiceUrl', true);
      const dateNow = Date.now();
      const file = new File([this.audioFile], dateNow + '.wav', {
        type: 'audio/wav',
        lastModified: dateNow
      });
      this.handleVoiceSuccess({ file }).then(() => {
        this.audioStatus = 0;
        this.recorder = null;
      });
    },
    handleVoiceSuccess({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      return new Promise(resolve => {
        uploadFileToS3(fd).then(fileInS3 => {
          const voiceUrl = fileInS3.data;
          const params = {
            voiceUrl
          };
          saveUserInfo(params)
            .then(() => {
              this.$message.success(i18n.t('upgrade_page_views_user_info_index_755'));
              this.$set(this.userInfo, 'voiceUrl', voiceUrl);
              this.$set(this.editingObj, 'voiceUrl', false);
              this.editUserInfo.voiceUrl = voiceUrl;
              resolve();
            })
            .catch(() => {
              this.$message.error(i18n.t('upgrade_page_views_user_info_index_756'));
              this.$set(this.editingObj, 'voiceUrl', false);
            });
        });
      });
    },
    handleAvatarSuccess(fileInS3) {
      if (this.uploadIndex < this.photoAlbumVoList.length) {
        this.$http
          .post('/user/photo/change', {
            id: this.photoAlbumVoList[this.uploadIndex].id,
            imageUrl: fileInS3
          })
          .then(({ data }) => {
            const { photoAlbumVoList } = this.userInfo;
            if (
              this.uploadIndex === undefined ||
              photoAlbumVoList.length <= this.uploadIndex
            ) {
              photoAlbumVoList.push(data);
            } else {
              photoAlbumVoList.splice(this.uploadIndex, 1, data);
            }
            this.$set(
              this.userInfo.photoAlbumVoList,
              'photoAlbumVoList',
              photoAlbumVoList
            );
            this.uploading = false;
            this.cutDialogVisiable = false;
            this.$message.success(i18n.t('upgrade_page_views_user_info_index_757'));
          })
          .catch(() => {
            this.uploading = false;
            this.$message.success(i18n.t('upgrade_page_views_user_info_index_758'));
          });
      } else {
        if (!this.userInfo.photoAlbumVoList) {
          this.userInfo.photoAlbumVoList = [];
        }
        this.$http
          .post('/user/photo/create', {
            imageUrl: fileInS3
          })
          .then(({ data }) => {
            this.userInfo.photoAlbumVoList.push(data);
            this.uploading = false;
            this.cutDialogVisiable = false;
            this.$message.success(i18n.t('upgrade_page_views_user_info_index_759'));
          })
          .catch(() => {
            this.uploading = false;
            this.$message.success(i18n.t('upgrade_page_views_user_info_index_760'));
          });
      }
    },
    //开启图片裁剪
    handleImgCut(i) {
      return obj => {
        if (this.uploading) return;
        this.uploading = true;
        this.uploadIndex = i;
        this.originData = obj.file;
        if (this.originData.type.split('/')[1] === 'gif') {
          this.$message({
            message:
              i18n.t('upgrade_page_views_user_info_index_761'),
            type: 'warning',
            duration: 5000
          });
          this.submitImg();
        } else {
          this.cutDialogVisiable = true;
        }
      };
    },
    submitImg() {
      const fd = new FormData();
      fd.append('file', this.originData);
      uploadImageToS3(fd).then(({ data }) => {
        this.handleAvatarSuccess(data);
      });
    },
    submitUserInfo(attr) {
      if (this.editingObj[attr]) return;
      this.$set(this.editingObj, attr, true);
      const params = {};
      const data = this.editUserInfo[attr];
      params[attr] = data;
      const linkList = ['fbUrl', 'igUrl', 'tkUrl'];
      if (linkList.includes(attr)) {
        linkList.forEach(item => {
          params[item] = this.userInfo[item] || '';
        });
        params[attr] = data;
        params['uuid'] = this.userInfo.uuid;
        this.$http
          .post('/user/save/link', params)
          .then(() => {
            this.$message.success(i18n.t('upgrade_page_views_player_list_index_205'));
            this.$set(this.userInfo, attr, data);
            this.$set(this.editingObj, attr, data);
            this.$set(this.handleInputVisible, attr, false);
          })
          .catch(err => {
            let message = i18n.t('upgrade_page_views_user_info_index_762');
            if (err.code === 622) {
              message = i18n.t('components_order_order_card_565');
            }
            this.$message.error(message);
            this.$set(this.editingObj, attr, '');
          });
      } else {
        saveUserInfo(params)
          .then(() => {
            this.$message.success(i18n.t('upgrade_page_views_player_list_index_205'));
            this.$set(this.userInfo, attr, data);
            this.$set(this.editingObj, attr, false);
            this.$set(this.handleInputVisible, attr, false);
          })
          .catch(err => {
            let message = i18n.t('upgrade_page_views_user_info_index_762');
            if (err.code === 622) {
              message = i18n.t('components_order_order_card_565');
            }
            this.$message.error(message);
            this.$set(this.editingObj, attr, false);
          });
      }
    },
    deleteVoice() {
      if (this.editingObj.voiceUrl) return;
      this.$set(this.editingObj, 'voiceUrl', true);
      this.$confirm({
        content: i18n.t('upgrade_page_views_user_info_index_763'),
        confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
        closeOnPressEscape: false
      }).then(() => {
        saveUserInfo({ voiceUrl: '' })
          .then(() => {
            this.$message.warning(i18n.t('upgrade_page_views_user_info_index_743'));
            this.$set(this.userInfo, 'voiceUrl', '');
            this.$set(this.editingObj, 'voiceUrl', false);
            this.$set(this.handleInputVisible, 'voiceUrl', false);
            this.$set(this.editUserInfo, 'voiceUrl', '');
          })
          .catch(() => {
            this.$message.error(i18n.t('upgrade_page_views_user_info_index_744'));
            this.$set(this.editingObj, 'voiceUrl', false);
            this.$set(this.handleInputVisible, 'voiceUrl', false);
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-container {
  padding-bottom: 64px !important;
  overflow-y: auto;
}
.user-info-card {
  min-height: 100%;
  padding: 40px 48px 72px;
  background: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  @include flex(space-between, flex-start);
  .delete-photo,
  .avatar-tip,
  .delete-voice {
    background-color: $color-gray-1;
    &:hover {
      background-color: rgba($color: $color-gray-1, $alpha: 0.85);
    }
  }
  .info-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: $color-gray-1;
  }
  .photo-list {
    width: 455px;
    .list-wrap {
      margin-top: 5px;
      @include flex(space-between);
      flex-wrap: wrap;
    }
    .avatar-uploader {
      position: absolute;
      z-index: -1;
      visibility: hidden;
    }
  }
  .photo-wrap {
    margin-top: 12px;
  }
  .photo-detail,
  .add-photo {
    width: 140px;
    height: 160px;
  }
  .photo-detail {
    background: no-repeat center center / cover;
    border: 1px solid $color-split;
    border-radius: 12px;
    position: relative;
    .delete-photo {
      @include flex;
      position: absolute;
      width: 22px;
      height: 22px;
      border-radius: 20px;
      right: 0;
      top: 0;
      transform: translate(50%, -50%);
    }
    .avatar-tip {
      padding: 3px 5px;
      border-radius: 22px;
      font-size: 12px;
      line-height: 16px;
      color: #ffffff;
      position: absolute;
      top: 5px;
      right: 5px;
    }
  }
  .add-photo {
    @include flex;
    background-color: $color-light;
    border: 2px dashed $color-split;
    box-sizing: border-box;
    border-radius: 12px;
    &:hover {
      background-color: rgba($color: $color-split, $alpha: 0.5);
    }
  }
  .info-detail {
    width: 422px;
    .info-title {
      @include flex(space-between);
      margin-bottom: 6px;
    }
    .info-content {
      position: relative;
      overflow: hidden;
      margin-bottom: 30px;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      .text-content {
        max-width: 100%;
        overflow: hidden;
      }
    }
    .edit-input {
      width: 100%;
      padding: 12px;
      background: #f9f9f9;
      mix-blend-mode: normal;
      border: 1px solid $color-split;
      border-radius: 8px;
    }
    .tool-btns {
      margin-top: 12px;
      @include flex(flex-end);
      button {
        width: 80px;
        height: 32px;
        font-size: 13px;
        line-height: 32px;
        text-align: center;
        border-radius: 16px;
      }
      .cancel-btn {
        color: $color-gray-2;
        background: $color-split;
      }
      .confirm-btn {
        @include button-yellow;
        margin-left: 10px;
      }
    }
    .edit-btn {
      padding: 7px;
      border-radius: 50%;
      &:hover {
        background: $color-split;
      }
    }
    .editing-btn {
      height: 33px;
    }
    .voice-info {
      @include flex(flex-start);
      float: left;
      .skill-voice {
        width: 94px;
        height: 36px;
      }
      .delete-voice {
        @include flex;
        opacity: 0;
        width: 22px;
        height: 22px;
        border-radius: 100%;
        margin: 0 16px;
      }
      &:hover {
        .delete-voice {
          opacity: 1;
        }
      }
    }
    .textarea-wrap {
      @include flex(center, flex-end, column);
      background: #f9f9f9;
      border: 1px solid $color-split;
      border-radius: 8px;
      padding: 12px 12px 8px;
      &.focus {
        background: #ffffff;
        box-shadow: 0px 2px 10px rgba(0, 22, 72, 0.1);
      }
      .edit-textarea {
        width: 100%;
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-1;
        resize: none;
        &::placeholder {
          color: $color-gray-4;
        }
      }
      .description-count {
        margin-top: 6px;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        color: $color-gray-3;
      }
    }
    .select-sex {
      width: 100%;
      & /deep/ .el-input__inner {
        background: #f9f9f9;
        border: 1px solid $color-split;
        border-radius: 8px;
        padding: 0 13px;
        width: 100%;
        height: 44px;
        @include flex(space-between);
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-1;
      }
    }
    .add-info {
      @include flex(flex-start);
      color: $color-link;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      &:hover span {
        text-decoration: underline;
      }
    }
  }
}
.upload-voice-wrap {
  .uploader {
    @include flex(flex-start);
    .record-voice {
      width: 157px;
      height: 36px;
      @include flex;
      color: $color-link;
      border: 1px solid $color-link;
      border-radius: 20px;
      span {
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        margin-left: 10px;
      }
      &:hover {
        background: rgba(0, 122, 255, 0.1);
      }
    }
    .select-text {
      margin: 0 32px;
    }
    .add-voice {
      color: $color-link;
      .upload-voice {
        padding: 0 3px;
        @include flex;
        color: $color-link;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        span {
          margin-left: 10px;
        }
        &:hover span {
          text-decoration: underline;
        }
      }
    }
  }
  .recording-voice {
    width: 303px;
    height: 36px;
    border-radius: 20px;
    padding: 0 12px 0 5px;
    background: linear-gradient(92.47deg, #222c43 -1.06%, #222c43 101.69%);
    @include flex(flex-start);
    .stop-icon {
      border: 2px solid #fff;
      border-radius: 50%;
      @include flex;
      width: 26px;
      height: 26px;
    }
  }
  .record-line {
    @include flex(flex-start);
    margin-left: 18px;
    flex: 1;
    &.play-state {
      @include voiceWavyLine('on', #fff, 54);
    }
    &.stop-state {
      @include voiceWavyLine('off', #fff, 54);
    }
  }
  .voice-second {
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    color: #fff;
  }
}
.tip-text {
  margin-top: 12px;
  font-size: 13px;
  line-height: 18px;
  color: $color-gray-3;
}
</style>
